import { Modal, Timeline } from "antd";

const AuditLogsModalView = ({ open, auditLogs = [], ticker = '', onClose }) => {
    return (
        <Modal
            title={`${ticker} Idea Log`}
            open={open}
            onCancel={onClose}
            footer={null}
            width={800}
        >
            <div style={{maxHeight: '50vh', overflowY: 'auto'}}>
                <Timeline
                    style={{paddingLeft: 12, paddingTop: 24, paddingBottom: 24}}
                    items={auditLogs.map((log, index) => {
                        let changes = {};
                        try {
                            changes = JSON.parse(log.changes || '{}');
                        } catch (error) {
                            console.error('Failed to parse changes:', error);
                        }
                        
                        return {
                            key: index,
                            dot: <div style={{width: 12, height: 12, backgroundColor: '#1890ff', borderRadius: '50%'}} />,
                            children: (
                                <div>
                                    <div style={{marginBottom: 8}}>
                                        <strong>{log.action}</strong>
                                        <span style={{marginLeft: 12, color: '#666', fontSize: 12}}>
                                            {log.operator}
                                        </span>
                                        <span style={{marginLeft: 12, color: '#999', fontSize: 12}}>
                                            {log.createdAt}
                                        </span>
                                    </div>
                                    {log.reason && (
                                        <div style={{marginBottom: 8, color: '#666', fontSize: 12}}>
                                            <strong>Reason:</strong> {log.reason}
                                        </div>
                                    )}
                                    {Object.keys(changes).filter(k => k !== 'ai_report_txt').length > 0 && (
                                        <div style={{marginBottom: 8}}>
                                            <strong style={{fontSize: 12}}>Changes:</strong>
                                            <div style={{marginTop: 4, paddingLeft: 12, fontSize: 12, color: '#666'}}>
                                                {Object.entries(changes).filter(([key]) => key !== 'ai_report_txt').map(([key, value]) => {
                                                    const oldVal = value?.old !== undefined ? String(value.old) : '';
                                                    const newVal = value?.new !== undefined ? String(value.new) : '';
                                                    return (
                                                        <div key={key} style={{marginBottom: 4}}>
                                                            <span style={{color: '#999'}}>{key}:</span>
                                                            <span style={{marginLeft: 8, color: '#ff4d4f', textDecoration: 'line-through'}}>{oldVal}</span>
                                                            <span style={{margin: '0 6px', color: '#999'}}>→</span>
                                                            <span style={{color: '#52c41a'}}>{newVal}</span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                    {(log.versionTag || log.versionTitle || log.versionBody) && (
                                        <div style={{
                                            marginTop: 8,
                                            padding: 12,
                                            border: '1px solid #d9d9d9',
                                            borderRadius: 6,
                                            backgroundColor: log.action?.startsWith('approve') ? '#f6ffed' : '#fafafa'
                                        }}>
                                            <div style={{marginBottom: 6, fontSize: 12}}>
                                                <span style={{color: '#999', fontWeight: 'bold'}}>Version Tag:</span>
                                                <span style={{marginLeft: 8, color: '#1890ff', fontWeight: 'bold'}}>{log.versionTag || '-'}</span>
                                            </div>
                                            <div style={{marginBottom: 6, fontSize: 12}}>
                                                <span style={{color: '#999', fontWeight: 'bold'}}>Version Title:</span>
                                                <span style={{marginLeft: 8, color: '#333'}}>{log.versionTitle || '-'}</span>
                                            </div>
                                            <div style={{fontSize: 12}}>
                                                <span style={{color: '#999', fontWeight: 'bold'}}>Version Body:</span>
                                                <span style={{marginLeft: 8, color: '#666'}}>{log.versionBody || '-'}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        };
                    })}
                />
            </div>
        </Modal>
    );
};

export default AuditLogsModalView;

